<template>
  <div class="project-page">
    <nav-bar />
    <project-list />
    <site-footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import SiteFooter from '@/components/SiteFooter'
import ProjectList from './project-new/ProjectList'

export default {
  name: 'Project',
  components: { NavBar, SiteFooter, ProjectList }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.project-page {
  min-height: 100vh;
  background: @bg-page;
}
</style>
